export var GridColumnWidth;
(function (GridColumnWidth) {
    GridColumnWidth["XS"] = "xs";
    GridColumnWidth["SM"] = "sm";
    GridColumnWidth["MD"] = "md";
    GridColumnWidth["LG"] = "lg";
    GridColumnWidth["XL"] = "xl";
    GridColumnWidth["XXL"] = "xxl";
    GridColumnWidth["ThreeXL"] = "threexl";
    GridColumnWidth["FourXL"] = "fourxl";
    GridColumnWidth["FiveXL"] = "fivexl";
    GridColumnWidth["AUTO"] = "auto";
    GridColumnWidth["Fragment"] = "1fr";
})(GridColumnWidth || (GridColumnWidth = {}));
/** Maps to a td element's align attribute */
export var GridColumnAlignment;
(function (GridColumnAlignment) {
    GridColumnAlignment["LEFT"] = "left";
    GridColumnAlignment["CENTER"] = "center";
    GridColumnAlignment["RIGHT"] = "right";
})(GridColumnAlignment || (GridColumnAlignment = {}));
